import React, { useState, useEffect } from "react";
import axios from "axios";
import { Bar } from 'react-chartjs-2';
import { Box, Typography, CircularProgress } from '@mui/material';
import config from "../config.js"

const SalesChart3 = () => {
    const [salesData, setSalesData] = useState([]);
    const { API_BASE_URL } = config;

    useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await axios.get(`${API_BASE_URL}/api/v1/SalesworkbookToJson`);
          setSalesData(response.data.data.Calcs);
        } catch (error) {
          console.error("Error fetching data: ", error);
        }
      };
  
      fetchData();
    }, [API_BASE_URL]);
    const prepareSalesChartData = () => {
        const labels = salesData.map(item => item.Salesman);
        const sales = salesData.map(item => item.Sales);
        const salesPerHour = salesData.map(item => item["Sales PH"]);
    
        return {
          labels: labels,
          datasets: [
            {
              label: 'Sales',
              type: 'bar',
              data: sales,
              backgroundColor: 'rgba(255, 99, 132, 0.5)',
              borderColor: 'rgba(255, 99, 132, 1)',
              borderWidth: 1
            },
            {
              label: 'Sales Per Hour',
              type: 'line',
              data: salesPerHour,
              borderColor: 'rgba(54, 162, 235, 1)',
              borderWidth: 1,
              fill: false
            }
          ]
        };
      };
    
      const prepareRevenueChartData = () => {
        const labels = salesData.map(item => item.Salesman);
        const revenue = salesData.map(item => item.Revenue);
        const revenuePerHour = salesData.map(item => item["Revenue PH"]);
    
        return {
          labels: labels,
          datasets: [
            {
              label: 'Revenue',
              type: 'bar',
              data: revenue,
              backgroundColor: 'rgba(255, 206, 86, 0.5)',
              borderColor: 'rgba(255, 206, 86, 1)',
              borderWidth: 1
            },
            {
              label: 'Revenue Per Hour',
              type: 'line',
              data: revenuePerHour,
              borderColor: 'rgba(75, 192, 192, 1)',
              borderWidth: 1,
              fill: false
            }
          ]
        };
      };
  return (
    <div>
         <div>
      <Box>
        {salesData.length === 0 ? (
          <CircularProgress />
        ) : (
          <Box>
            
            <div>
              <Typography variant="h6">Sales</Typography>
              <Bar data={prepareSalesChartData()} />
            </div>
            <div>
              <Typography variant="h6">Revenue</Typography>
              <Bar data={prepareRevenueChartData()} />
            </div>
          </Box>
        )}
      </Box>
    </div>
      
    </div>
  )
}

export default SalesChart3
